import React, { useEffect } from 'react';
import { tns } from 'tiny-slider/src/tiny-slider';
import carte1 from '../../static/images/section4-dessiner/cartepostale-DEI-ecole-1200.png';
import portrait1 from '../../static/images/section4-dessiner/cartepostale-DEI-lesfemmespeuventdirenon-1200.png';
import portrait2 from '../../static/images/section4-dessiner/cartepostale-DEI-lesfillesshabillentcommeellesveulent4-1200.png';
import portrait3 from '../../static/images/section4-dessiner/cartepostale-DEI-viole-1200.png';
import portrait4 from '../../static/images/section4-dessiner/poster-DEI-choice-sunflower-der-web.png';
import carte2 from '../../static/images/section4-dessiner/poster-DEI-croirelesvictimes-apercu-1200.png';
import carte3 from '../../static/images/section4-dessiner/poster-DEI-pressionaumariage-apercu-2-1200.png';
import dessin from '../../static/images/section4-dessiner/dessin.png';
import photo1 from '../../static/images/section4-dessiner/photo1.jpg';
import photo2 from '../../static/images/section4-dessiner/photo2.jpg';
import photo3 from '../../static/images/section4-dessiner/photo3.jpg';
import photo4 from '../../static/images/section4-dessiner/photo4.jpg';
import photo5 from '../../static/images/section4-dessiner/photo5.jpg';
import photo7 from '../../static/images/section4-dessiner/photo7.jpg';
import photo8 from '../../static/images/section4-dessiner/photo8.jpg';
import photo9 from '../../static/images/section4-dessiner/photo9.jpg';
import photo10 from '../../static/images/section4-dessiner/photo10.jpg';
import photo11 from '../../static/images/section4-dessiner/photo11.jpg';

export const Section4Dessiner = ({ setImgModalOpen, setImgModalSrc }) => {
  const openModal = (src) => () => {
    setImgModalOpen(true);
    setImgModalSrc(src);
  };
  useEffect(() => {
    // code to run after render goes here
    tns({
      container: '#portrait-slider',
      items: 2,
      slideBy: 1,
      autoplay: true,
      swipeAngle: false,
      speed: 1000,
      controls: false,
      nav: false,
      autoplayButton: false,
      autoplayText: ['', ''],
      gutter: 15,
    });

    tns({
      container: '#carte-slider',
      items: 1,
      slideBy: 'page',
      autoplay: true,
      swipeAngle: false,
      axis: 'vertical',
      speed: 600,
      controls: false,
      nav: false,
      autoplayButton: false,
      autoplayText: ['', ''],
    });
    tns({
      container: '#illu-photo-slider',
      items: 2,
      slideBy: 'page',
      autoplay: true,
      controls: false,
      nav: false,
      autoplayButton: false,
      autoplayText: ['', ''],
      speed: 1000,
      gutter: 15,
    });
  }, []);
  return (
    <section id="section4-dessiner" className="mb-0">
      <h2 className="mb-6">Dessiner</h2>
      <div className="pink-bg w-10/12 m-auto">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="grey-bg w-full md:w-1/2 p-4">
            <img src={dessin} alt="Main d'enfant qui dessine" className="h-full" />
          </div>
          <div className="w-full md:w-1/2 p-4">
            <div className="flex">
              <div id="portrait-slider">
                <img src={portrait1} onClick={openModal(portrait1)} />
                <img src={portrait2} onClick={openModal(portrait2)} />
                <img src={portrait3} onClick={openModal(portrait3)} />
                <img src={portrait4} onClick={openModal(portrait4)} />
              </div>

            </div>
          </div>
        </div>
        <p className="text p-4">
          Découverte de diverses techniques d’art plastique (dessin, collage, peinture etc.) pour permettre aux enfants d’illustrer les slogans qu’ils/elles vont diffuser via des affiches et cartes postales.
        </p>
      </div>
      <div className="flex flex-col md:flex-row w-10/12 m-auto items-center">
        {/* <div className="blue-bg hidden md:block md:w-1/2">
          <div className="trais" />
        </div> */}
        <div className="w-full md:w-1/2 p-4">
          <div id="illu-photo-slider">
            <img src={photo1} onClick={openModal(photo1)} alt="photo1" />
            <img src={photo2} onClick={openModal(photo2)} alt="photo2" />
            <img src={photo3} onClick={openModal(photo3)} alt="photo3" />
            <img src={photo4} onClick={openModal(photo4)} alt="photo4" />
            <img src={photo5} onClick={openModal(photo5)} alt="photo5" />
            <img src={photo7} onClick={openModal(photo7)} alt="photo6" />
            <img src={photo8} onClick={openModal(photo8)} alt="photo7" />
            <img src={photo9} onClick={openModal(photo9)} alt="photo8" />
            <img src={photo10} onClick={openModal(photo10)} alt="photo9" />
            <img src={photo11} onClick={openModal(photo11)} alt="photo10" />
          </div>
        </div>
        <div className="w-full md:w-1/2 p-4">
          <div id="carte-slider">
            <img src={carte1} onClick={openModal(carte1)} />
            <img src={carte2} onClick={openModal(carte2)} />
            <img src={carte3} onClick={openModal(carte3)} />
          </div>
        </div>
      </div>
    </section>
  );
};
